import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Map, List } from 'immutable'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { EN } from '../../services/languages/constants'
import { SCREEN_TYPE_CENTERS } from '../../services/page-manager/entities/index'
import { connect as connectPage } from '../Page/connect'
import { getUserLanguagePrimary } from '../../services/user/index'
import { H1 } from '../Heading/index'
import { formatSectionData } from './utils'
import TopicsPageV3Card from './TopicsPageV3Card'

const TopicsPageV2 = (props) => {
  const {
    sectionStore = Map(),
    sectionIds = List(),
    staticText = Map(),
    viewportWidth,
    nodeTerm,
    language,
  } = props

  const reorderedSectionIds = useMemo(
    () => formatSectionData({ sectionIds, viewportWidth }),
    [sectionIds, viewportWidth],
  )

  return (
    <div className="topics-v3">
      <div className="topics-v3__title">
        <H1>{staticText.get('topics')}</H1>
        <p>{staticText.get('click')}</p>
      </div>
      <div className="topics-v3__wrapper">
        {
          reorderedSectionIds.map((columnSectionIds, columnIndex) => (
            <div key={columnIndex} className="topics-v3__column">
              {List.isList(columnSectionIds) && columnSectionIds.map((sectionId) => (
                <TopicsPageV3Card
                  key={sectionId}
                  sectionId={sectionId}
                  language={language}
                  staticText={staticText}
                  sectionStore={sectionStore}
                  nodeTerm={nodeTerm}
                />
              ))}
            </div>
          ))
        }
      </div>
    </div>
  )
}

TopicsPageV2.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  sectionStore: ImmutablePropTypes.map.isRequired,
  nodeTerm: ImmutablePropTypes.map.isRequired,
  language: PropTypes.string.isRequired,
  sectionIds: ImmutablePropTypes.list.isRequired,
  viewportWidth: PropTypes.number.isRequired,
}

export default compose(
  connectPage({ storeBranch: 'topics' }),
  connectRedux(
    (state) => {
      const {
        pmSection,
        pmScreen,
        user,
        staticText,
        app,
        node,
      } = state
      const language = getUserLanguagePrimary(user) || EN
      const screenStore = pmScreen.getIn([SCREEN_TYPE_CENTERS, language]) || Map()
      const sectionIds = screenStore.getIn(['data', 'sectionIds']) || List()
      const nodeTerm = node.get('term') || Map()

      return {
        staticText: staticText.getIn(['data', 'topicsV3', 'data'], Map()),
        sectionStore: pmSection,
        language,
        sectionIds,
        viewportWidth: app.getIn(['viewport', 'width']),
        nodeTerm,
      }
    },
  ),
)(TopicsPageV2)
